// RailBottomV2 — đáy MENU TRÁI ở giao diện v2. Chỉ còn UserMenu bản dưới 1024px.
//
// Nút "Giao diện cũ" ĐÃ BỎ (sếp Phú chốt 17/08): v2 là giao diện chính thức, không còn
// lối quay lui trong app. Công tắc `floating` bên v1 giữ nguyên — đó là đường ĐI TỚI v2
// cho máy còn kẹt localStorage `ui_version='v2'` chưa từng đặt.
//
// ⚠️ Slot `primaryBottomSlot` THAY THẾ HẲN thứ đang đứng ở đáy rail — xem
// cnv-ui/src/components/layout/sidebar/SidebarPrimary.jsx (`bottomSlot !== undefined
// ? bottomSlot : <avatar/>`). Ở v1 admin Connect đang truyền thẳng `<UserMenu />` vào slot
// đó, nên bản v2 PHẢI tự gánh lại UserMenu, nếu không user mất lối vào cài đặt cá nhân
// (menu Connect không có mục nào trỏ `/me`).
//
// Desktop v2 đã có UserMenu trên thanh trên cùng nên bản ở đây chỉ hiện dưới 1024px —
// đúng ngưỡng mà `.v2-topbar` bị ẩn (ui-v2.css). Hai chỗ không bao giờ hiện cùng lúc;
// từ 1024px trở lên khối này rỗng nên ui-v2.css ẩn hẳn (khỏi trơ đường kẻ + padding).

import UserMenu from '@cnv/ui/layout/sidebar/UserMenu';

export default function RailBottomV2() {
  return (
    <div className="v2-rail-bottom shrink-0">
      <div className="v2-rail-bottom__user lg:hidden">
        <UserMenu />
      </div>
    </div>
  );
}
